var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCardi = function SvgCardi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M18.25 7H5.75a.75.75 0 0 0-.75.75v8.5a.75.75 0 0 0 .75.75h12.5a.75.75 0 0 0 .75-.75v-8.5a.75.75 0 0 0-.75-.75m-.75 1.5V10h-11V8.5zm-11 7V12h11v3.5z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCardi);
export default ForwardRef;